/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListRIRecommendationsResponse {
    getFixupPrototypeFunction() { return ListRIRecommendationsResponse.fixupPrototype; }

    static newInstance(model: Partial<ListRIRecommendationsResponse>): ListRIRecommendationsResponse {
        let obj = Object.assign(new ListRIRecommendationsResponse(), model);
        ListRIRecommendationsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListRIRecommendationsResponse>): ListRIRecommendationsResponse {
        if (!model) return null;
        return ListRIRecommendationsResponse.newInstance(<ListRIRecommendationsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListRIRecommendationsResponse) {
        if (!obj) return;

        models.ListRIRecommendationsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListRIRecommendationsResponse): boolean {
        Object.setPrototypeOf(obj, ListRIRecommendationsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.recommendations) {
            for (let val of this.recommendations) {
                models.Recommendations.fixupPrototype(val);
            }
        }
    }

    /**
     * Total count
     */
    total_count: number;

    /**
     * Page wise count
     */
    page_count: number;

    /**
     * Recommendations suggested
     */
    recommendations: Array<models.Recommendations>;

}
